window.UP = {
    ScrollToFragment: (elementId) => {
        document.documentElement.scrollTop = 0;
    },

    DownloadFile: (url, filename) => {
        const link = document.createElement('a');
        link.download = filename;
        link.href = url;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    },

    FocusElement: (elementId) => {
        const element = document.getElementById(elementId);
        if (element) {
            element.focus();
        }
    },

    DownloadFileFromText: (content, filename, mimeType) => {
        const blob = new Blob([content], {type: mimeType});
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = filename;
        a.click();
        URL.revokeObjectURL(url);
    },

    GetElementRect: (selector) => {
        const el = document.querySelector(selector);
        if (!el) return null;
        const r = el.getBoundingClientRect();
        return {top: r.top, bottom: r.bottom, left: r.left, right: r.right, width: r.width, height: r.height};
    },

    GetViewportWidth: () => window.innerWidth,

    ScrollIntoView: (target, options) => {
        const element = typeof target === 'string' ? document.getElementById(target) : target;
        if (element && typeof element.scrollIntoView === 'function') {
            element.scrollIntoView(options || {behavior: 'smooth', block: 'nearest', inline: 'center'});
        }
    },

    ScrollRail: (target, delta) => {
        const element = typeof target === 'string' ? document.getElementById(target) : target;
        if (element && typeof element.scrollBy === 'function') {
            element.scrollBy({left: delta, behavior: 'smooth'});
        }
    },

    RequestPersistentStorage: async () => {
        if (navigator.storage && navigator.storage.persist) {
            return await navigator.storage.persist();
        }
        return false;
    },

    RemoveLocalStorageByPrefix: (prefix) => {
        const keys = [];
        for (let i = 0; i < localStorage.length; i++) {
            const key = localStorage.key(i);
            if (key && key.startsWith(prefix)) {
                keys.push(key);
            }
        }
        keys.forEach(key => localStorage.removeItem(key));
    }
};
